import type { ReactNode } from 'react';

interface AppShellProps {
  children?: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="flex h-screen flex-col">
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
